import apiService from 'services/api.service'
import store from 'store'

export default {
    getReservations(params) {
        const locale = store.state.locale;
        return apiService.getFrApi({
            url: 'reservations/getReservationsForFilter',
            method: 'get',
            params: params,
            locale: locale
        });
    },

    getHotels() {
        const locale = store.state.locale;
        return apiService.getFrApi({
            url: 'reservations/getHotelList',
            method: 'get',
            locale: locale
        });
    },

    getStatuses() {
        const locale = store.state.locale;
        return apiService.getFrApi({
            url: 'reservations/getStatusList',
            method: 'get',
            locale: locale
        });
    },

    getConfirms() {
        const locale = store.state.locale;
        return apiService.getFrApi({
            url: 'reservations/getConfirmList',
            method: 'get',
            locale: locale
        });
    },

    getMarkets() {
        const locale = store.state.locale;
        return apiService.getFrApi({
            url: 'reservations/getMarketList',
            method: 'get',
            locale: locale
        });
    },

    getReasons(params) {
        const locale = store.state.locale;
        return apiService.getFrApi({
            url: 'reservations/getReasonsList',
            method: 'get',
            params: params,
            locale: locale
        });
    },

    setStatusForReservations(params) {
        const locale = store.state.locale;
        return apiService.getFrApi({
            url: 'reservations/setStatusForReservations',
            method: 'get',
            params: params,
            locale: locale
        });
    },

    getHistory(params) {
        const locale = store.state.locale;
        return apiService.getFrApi({
            url: 'reservations/getHistory',
            method: 'get',
            params: params,
            locale: locale
        });
    },

    setNote(params) {
        const locale = store.state.locale;
        return apiService.getFrApi({
            url: 'reservations/setNote',
            method: 'get',
            params: params,
            locale: locale
        });
    }
}
